import type { Messages } from './en.js';

export const de: Messages = {
  'app.title': 'Sync Port · P2P-Dateiübertragung',
  'secure.badge': 'Ende-zu-Ende-verschlüsselt · direkt von Gerät zu Gerät · nichts wird auf Servern gespeichert',
  'secure.tooltip':
    'WebRTC-Datenkanäle sind zwischen den beiden Geräten mit DTLS verschlüsselt. Server und TURN-Relay sehen nur verschlüsselte Daten.',
  'error.title': 'Verbindung verloren',
  'error.peerFailed': 'Die Direktverbindung ist fehlgeschlagen. Prüfe das Netzwerk oder die TURN-Relay-Konfiguration.',
  'error.signaling': 'Der Signalisierungsserver ist nicht erreichbar.',
  'error.roomNotFound': 'Zu diesem Link oder dieser PIN gibt es keine offene Übertragung. Vielleicht wurde die Seite geschlossen oder der Code vertippt.',
  'error.roomFull': 'Jemand anderes hat diesen Link bereits geöffnet. Jeder Link gilt nur für einen Empfänger.',
  'notFound.tagline': 'An dieser Koordinate ist nur leerer Raum.',
  'notFound.text': 'Die aufgerufene Seite existiert nicht.',
  'notFound.action': 'Datei senden',
  'action.startOver': 'Neu beginnen',
  'action.retry': 'Erneut versuchen',
  'action.cancel': 'Abbrechen',
  'action.dismiss': 'Schließen',
  'sender.tagline': 'Dateien über eine private, verschlüsselte Verbindung zwischen Geräten übertragen. Nichts bleibt im Orbit.',
  'drop.title': 'Datei zum Senden wählen',
  'drop.hint': 'Tippen oder Datei hierher ziehen · beliebige Größe',
  'share.title': 'Diesen Link teilen',
  'share.text': 'Auf dem anderen Gerät öffnen oder den Code mit der Handykamera scannen.',
  'share.linkLabel': 'Link zum Teilen',
  'share.copy': 'Link kopieren',
  'share.native': 'Teilen…',
  'share.or': 'oder',
  'share.pinHint': 'Diese PIN auf der Startseite des anderen Geräts eingeben.',
  'share.pinLabel': 'Übertragungs-PIN',
  'share.copied': 'In die Zwischenablage kopiert',
  'share.shared': 'Geteilt',
  'share.linkMessage': 'Öffne diesen Link, um eine Datei von mir zu empfangen:',
  'share.unavailable': 'Dieser Browser hat kein systemeigenes Teilen-Menü.',
  'clipboard.blocked': 'Der Browser blockiert das Kopieren. Markiere den Link und kopiere ihn manuell.',
  'pin.title': 'PIN oder QR-Code erhalten?',
  'pin.text': 'Gib den 9-stelligen Code vom sendenden Gerät ein oder scanne dessen QR-Code.',
  'pin.receive': 'Empfangen',
  'pin.scan': '📷 Stattdessen QR-Code scannen',
  'pin.incomplete': 'Gib alle {count} Ziffern der PIN ein.',
  'scan.hint': 'Richte die Kamera auf den QR-Code des sendenden Geräts',
  'scan.notOurs': 'Das ist kein Sync-Port-Link. Suche den Code auf dem sendenden Gerät.',
  'camera.denied': 'Der Kamerazugriff wurde verweigert. Erlaube ihn in den Browsereinstellungen oder gib die PIN ein.',
  'camera.notFound': 'Auf diesem Gerät wurde keine Kamera gefunden.',
  'camera.busy': 'Die Kamera wird von einer anderen App verwendet.',
  'camera.failed': 'Die Kamera konnte nicht geöffnet werden ({reason}).',
  'sender.status.creatingRoom': 'Privater Raum wird erstellt',
  'sender.status.waitingReceiver': 'Warten, bis der Empfänger den Link öffnet',
  'sender.status.receiverConnected': 'Empfänger verbunden, verschlüsselter Direktkanal wird geöffnet',
  'sender.status.waitingDestination': 'Verschlüsselter Kanal offen. Warten, bis der Empfänger den Speicherort wählt',
  'sender.status.beaming': 'Datei wird durch den Weltraum gebeamt',
  'sender.status.delivered': 'Zugestellt',
  'status.failed': 'Übertragung fehlgeschlagen',
  'progress.sending': 'Senden',
  'progress.receiving': 'Empfangen',
  'progress.sentDetail': 'Gesendet {sent} · Empfänger bestätigt {acked}',
  'progress.deliveredDetail': 'Der Empfänger hat die ganze Datei.',
  'progress.arrivedDetail': 'Jedes Byte ist angekommen.',
  'progress.of': '{done} von {total}',
  'progress.speedEta': '{speed} · noch {eta}',
  'route.finding': 'Beste Route wird gesucht',
  'route.direct': 'Direktverbindung',
  'route.nat': 'Direktverbindung durch NAT',
  'route.relay': 'Über TURN-Relay',
  'route.relayOver': 'Über TURN-Relay per {protocol}',
  'sender.sendAnother': 'Weitere Datei senden',
  'receiver.tagline': 'Eingehende Übertragung über eine private, verschlüsselte Verbindung. Lass diese Seite offen, bis die Datei gelandet ist.',
  'receiver.status.contacting': 'Sender wird kontaktiert',
  'receiver.status.connected': 'Mit dem Sender verbunden, verschlüsselter Direktkanal wird geöffnet',
  'receiver.status.channelOpen': 'Verschlüsselter Kanal offen, warten auf die Dateidetails',
  'receiver.status.chooseDestination': 'Speicherort wählen, um den Empfang zu starten',
  'receiver.status.receiving': 'Empfangen',
  'receiver.status.complete': 'Fertig',
  'dest.title': 'Bereit zum Empfangen',
  'dest.picker.button': 'Speicherort wählen',
  'dest.picker.text': '{size} kommen an. Wähle ein Ziel, die Datei wird direkt dorthin geschrieben.',
  'dest.worker.button': 'Auf diesem Gerät speichern',
  'dest.worker.text': '{size} kommen an. Die Datei wird direkt in den Downloads-Ordner geschrieben.',
  'dest.memory.button': 'Datei empfangen',
  'dest.memory.text': '{size} kommen an. Dieser Browser hält die Datei im Tab, bis du sie danach speicherst.',
  'dest.cancelled': 'Wähle einen Speicherort, um den Empfang zu starten.',
  'landed.title': 'Sicher gelandet',
  'landed.chosenFolder': 'Gespeichert als {name} im gewählten Ordner.',
  'landed.downloads': 'Im Downloads-Ordner des Browsers gespeichert.',
  'landed.openWith': 'Öffnen mit…',
  'landed.sendYourself': 'Selbst eine Datei senden',
  'memory.received': '{size} empfangen. Speichere die Datei auf diesem Gerät.',
  'memory.save': 'Datei speichern',
  'memory.saved': 'Im Downloads-Ordner des Browsers gespeichert. Du kannst die Datei auch sofort in einer anderen App öffnen.',
  'memory.saveAgain': 'Erneut speichern',
  'error.inboxNotFound': 'Diese Postfachnummer existiert nicht.',
  'error.inboxUnauthorized': 'Der Schlüssel passt nicht zu diesem Postfach.',
  'error.declined': 'Der Postfachinhaber hat diese Datei abgelehnt.',
  'error.inboxLimit': 'Auf diesem Server können keine weiteren Postfächer erstellt werden.',
  'home.inboxLink': 'Postfach erstellen',
  'inbox.tagline': 'Dein dauerhaftes Postfach. Wer den Code scannt, kann dir eine Datei anbieten; du entscheidest, was du annimmst.',
  'inbox.create.title': 'Postfach erstellen',
  'inbox.create.text': 'Erhalte eine dauerhafte Nummer und einen QR-Code. Wer ihn scannt, kann dir eine Datei anbieten; nichts kommt an, bevor du annimmst.',
  'inbox.create.button': 'Mein Postfach erstellen',
  'inbox.connect.title': 'Schon ein Postfach?',
  'inbox.connect.text': 'Füge den geheimen Schlüssel ein, um das Postfach auf diesem Gerät zu nutzen. Die Nummer ist optional: sie lässt sich aus dem Schlüssel ermitteln.',
  'inbox.connect.numberOptional': 'Postfachnummer (optional)',
  'error.keyUnknown': 'Zu diesem Schlüssel passt kein Postfach.',
  'inbox.connect.number': 'Postfachnummer',
  'inbox.connect.key': 'Geheimer Schlüssel',
  'inbox.connect.button': 'Verbinden',
  'inbox.key.title': 'Dein geheimer Schlüssel',
  'inbox.key.text': 'Bewahre Nummer und Schlüssel zusammen an einem sicheren Ort auf. Der Schlüssel wird nur hier angezeigt und ist mit der Nummer der einzige Weg, dieses Postfach auf einem anderen Gerät zu öffnen.',
  'inbox.key.copy': 'Nummer und Schlüssel kopieren',
  'inbox.key.copied': 'Nummer und Schlüssel kopiert',
  'inbox.key.done': 'Ich habe beides gespeichert',
  'inbox.number.title': 'Deine Postfachnummer',
  'inbox.number.text': 'Drucke diesen Code aus oder zeige ihn auf einem Bildschirm. Kunden scannen ihn oder geben die Nummer auf der Startseite ein.',
  'inbox.status.connecting': 'Verbindung zu deinem Postfach wird hergestellt',
  'inbox.status.online': 'Online. Warten auf Kunden',
  'inbox.status.reconnecting': 'Verbindung verloren. Neuer Versuch',
  'inbox.requests.title': 'Eingehende Anfragen',
  'inbox.requests.empty': 'Noch keine Anfragen. Sie erscheinen hier, sobald ein Kunde eine Datei sendet.',
  'inbox.request.accept': 'Annehmen und speichern…',
  'inbox.request.decline': 'Ablehnen',
  'inbox.request.connecting': 'Angenommen. Verbindung zum Kunden wird aufgebaut',
  'inbox.request.cancelled': 'Der Kunde ist gegangen, bevor du geantwortet hast.',
  'inbox.refresh': 'Aktualisieren',
  'inbox.forget': 'Dieses Postfach auf diesem Gerät vergessen',
  'toInbox.tagline': 'Datei an Postfach {number} senden. Der Inhaber sieht deine Anfrage und entscheidet.',
  'toInbox.status.announcing': 'Deine Datei wird dem Postfach angekündigt',
  'toInbox.status.waitingOnline': 'Im Postfach eingegangen. Warten auf Freigabe',
  'toInbox.status.waitingOffline': 'Der Postfachinhaber ist gerade nicht online. Deine Anfrage wartet, bis er zurück ist',
  'toInbox.status.accepted': 'Angenommen. Verschlüsselter Direktkanal wird geöffnet',
  'inbox.print': 'Plakat drucken (PDF)',
  'poster.title': 'Schick mir deine Dateien',
  'poster.number': 'Postfachnummer',
  'poster.step1': 'Scanne den Code mit der Handykamera.',
  'poster.step2': 'Oder öffne {link} und gib die Nummer ein.',
  'poster.step3': 'Wähle die Datei. Wir nehmen sie direkt hier am Tresen an.',
  'poster.footer': 'Sync Port · Ende-zu-Ende-verschlüsselt, direkt von Gerät zu Gerät. Nichts wird auf Servern gespeichert.',
  'install.title': 'Sync Port installieren',
  'install.native': 'Zum Startbildschirm hinzufügen für schnellen Zugriff.',
  'install.ios': 'Tippe auf „Teilen“ und dann auf „Zum Home-Bildschirm“.',
  'install.button': 'Installieren',
};
